import { Box, Typography } from "@mui/material";
import './not-found.css';

function NotFound() {
    return (
        <Box sx={{ py: 6, px: 2}} className="not-found-container" >
            <Typography variant="h1" className="not-found__title">
                404
            </Typography>
            <Typography variant="h4" className="not-found__description">
                Lo sentimos, no pudimos encontrar la información que estas buscando.
            </Typography>
        </Box>
    );
}

export default NotFound;